import { Component, DestroyRef, EventEmitter, inject, input, OnInit, Output } from '@angular/core';
import {
  NbAccordionModule,
  NbAutocompleteModule,
  NbButtonModule,
  NbCardModule,
  NbFormFieldModule,
  NbInputModule,
  NbListModule,
  NbOptionModule,
  NbSelectModule,
  NbTabsetModule,
  NbToggleModule,
} from '@nebular/theme';
import { CommonModule, LowerCasePipe } from '@angular/common';
import { RightPanelDialogService } from '../../../../../@core/utils/right-panel-dialog.service';
import { TranslateModule } from '@ngx-translate/core';
import { FormGroupFromWithArray, IInvestmentWizard, InitiativeForm } from '../wizard-interface';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import {
  InitiativeTypeSelectorComponent,
} from '../../initiative-wizard/initiative-type-selector/initiative-type-selector.component';
import { KPI } from '../../../../../@core/api';
import { filter, map } from 'rxjs/operators';
import { UsernamePipe } from '../../../../pipes';
import { InitiativeResponsiblesService } from '../../../../../@core/utils/initiative-responsibles.service';
import { Observable } from 'rxjs';
import { InvestmentWizardService } from '../../../../../@core/utils/investment-wizard-service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { InitiativesService, ScopeService } from '../../../../../@core/utils';
import { idMapToArray } from '../../../../../@core/utils/scope.service';
import { PerimeterEnergyTrajectoryService } from '../../../../../@core/utils/perimeter-energy-trajectory.service';
import * as R from 'ramda';
import { IntegerOnlyDirective } from '../../../../../@core/directives';
import { gainValidator, GainFieldsVisibility } from '../../../side-forms/initiative-form/initiative-gain.validator';


@Component({
  selector: 'app-initiative-type-wrapper',
  standalone: true,
  imports: [
    InitiativeTypeSelectorComponent,
    NbCardModule,
    TranslateModule,
  ],
  template: `
    <nb-card style="width: 100%; height: 100%; margin: 0; border-radius: 0;">
      <nb-card-header style="font-weight: normal; color: #dc3545">
        {{ 'Fidji ACT Categories' | translate }}
      </nb-card-header>
      <app-initiative-type-selector style="overflow-y: scroll; height: calc(100vh - 50px)"
                                    [selectedTypeId]="selectedTypeId()"
                                    (typeSelected)="typeSelected.emit($event)" />
    </nb-card>
  `,
})
export class InitiativeTypeWrapperComponent {

  selectedTypeId = input<number>();

  @Output() typeSelected = new EventEmitter<KPI.InitiativeType>();

}

@Component({
  selector: 'app-gain-energy-carbon',
  standalone: true,
  imports: [
    NbListModule,
    CommonModule,
    NbInputModule,
    NbFormFieldModule,
    TranslateModule,
    ReactiveFormsModule,
    NbToggleModule,
    NbAutocompleteModule,
    NbOptionModule,
    UsernamePipe,
    NbSelectModule,
    NbAccordionModule,
    NbButtonModule,
    NbTabsetModule,
    LowerCasePipe,
    IntegerOnlyDirective,
    NbCardModule
  ],
  template: `
    <div class="wrapper">
        <nb-card-header *ngIf="existingInvestment">
          <div class="title">{{ "Energy/Carbon gains" | translate }}</div>
          <div class="cancel-button" (click)="closed.emit()">
            <i class="fa-light fa-x"></i>
          </div>
        </nb-card-header>
      <form [formGroup]="energyCarbonForm" autocomplete="off">
        <div class="form-group">
          <div class="form-field flex-row">
            <label for="enabled" class="me-auto w-50">{{ "Label FIDJI ACT" | translate }}</label>
            <div class="col-10">
              <span>
              {{ energyCarbonForm.controls['initiative_type'].value?.name || '-' }}
            </span>
            </div>
            <div class="col-2 text-end">
              <nb-toggle [checked]="energyCarbonForm.controls['enabled'].value"
                         (checkedChange)="formToggle($event)"></nb-toggle>
            </div>
          </div>
          @if (energyCarbonForm.controls['enabled'].value) {
            <div class="form-field">
              <label for="responsible">{{ 'Responsible action' | translate }} {{ '(optional)' | translate }}</label>
              <input type="text" nbInput fullWidth (input)="onChange($event)" placeholder="-"
                     [nbAutocomplete]="autoResponsible" [value]="energyCarbonForm.controls['responsible'].value">
              <input type="text" formControlName="responsible" id="responsible" hidden>
              <nb-autocomplete #autoResponsible (selectedChange)="onResponsibleSelected($event)">
                @for (user of filteredResponsible$ | async; track user) {
                  <nb-option [value]="user">
                    {{ user | ngxUsername }}
                  </nb-option>
                }
              </nb-autocomplete>
            </div>
            <div class="form-field">
              <label for="initially_proposed_by">{{ 'Action initially proposed by' | translate }}
                {{ "(optional)" | translate }}
              </label>
              <input type="text" nbInput fullWidth placeholder="-"
                     id="initially_proposed_by" formControlName="initially_proposed_by"
              >
            </div>
            <div class="form-field">
              <label for="description">{{ 'Action description' | translate }} {{ '(optional)' | translate }}</label>
              <textarea type="text" nbInput fullWidth placeholder="-"
                        id="description" formControlName="description"></textarea>
            </div>

                <div formArrayName="gains">
                  <!-- GAIN FORMS -->
                  <nb-accordion multi class="mt-4">
                    @for (gain of gains.controls; track gain; let first = $first; let i = $index) {
                      <nb-accordion-item expanded="true">
                        <nb-accordion-item-header class="d-flex gain-header">
                          <div class="col-1 text-start">
                          </div>
                          <div class="col-10 px-2 text-center">
                            {{ "Gain #" | translate }}{{ i + 1 }}
                          </div>
                          <div class="col-1 text-end">
                            <a
                              nbButton
                              ghost
                              status="primary"
                              (click)="removeGain(i)"
                              class="accordion-button col-3"
                            >
                              <i class="fal fa-trash-can fa-xl"></i>
                            </a>
                          </div>

                        </nb-accordion-item-header>
                        <nb-accordion-item-body>
                          <ng-container *ngTemplateOutlet="fields; context: { i, gain }"></ng-container>
                        </nb-accordion-item-body>
                      </nb-accordion-item>
                    }
                    <!-- ADD A NEW GAIN -->
                    <nb-accordion-item expanded="false"
                                       class="accordion-item-as-button">
                      <nb-accordion-item-header>
                        <button class="btn btn-link text-dark" (click)="addGain()" [disabled]="isGainTypeNone" style="font-size: 13px !important;">
                          (+)
                          @if (gains?.length) {
                            {{ "Add another gain" | translate }}
                          } @else {
                            {{ "Add a gain" | translate }}
                          }
                        </button>
                      </nb-accordion-item-header>
                    </nb-accordion-item>
                  </nb-accordion>
                </div>
          }
        </div>
      </form>
    </div>

    <!-- FIELDS TEMPLATE -->
    <ng-template #fields let-i="i" let-gain="gain">
      <div class="form-group" [formGroup]="gain">

        <!-- FULL STOP (ABANDON ENERGIE FOSSILE) -->
        @if (isAbandonType) {
          <div class="form-field toggle">
            <label for="full_stop">{{ 'Abandon energy fossil' | translate }}</label>
            <nb-toggle status="success"
                       id="full_stop"
                       formControlName="full_stop"
            ></nb-toggle>
          </div>
        }

        <!-- KWH GAIN -->
        @if (showEnergyInput('ENERGY_INPUT')) {
          <div class="form-field">
            <label for="theoretical_savings_full_year">{{ "Gain #{nb} in kWh/year" | translate: { nb: i + 1 } }}</label>
            <input
              nbInput
              id="theoretical_savings_full_year"
              type="number"
              formControlName="theoretical_savings_full_year"
              fullWidth
              integerOnly
            >
          </div>
        }

        <!-- KG CO2 GAIN -->
        @if (showRefrigerantInput) {
          <div class="form-field">
            <label
              for="theoretical_greenhouse_gas_savings_full_year">{{ "Gain #{nb} in kgCO2/year" | translate: { nb: i + 1 } }}</label>
            <input
              nbInput
              id="theoretical_greenhouse_gas_savings_full_year"
              type="number"
              formControlName="theoretical_greenhouse_gas_savings_full_year"
              fullWidth
              integerOnly
            >
          </div>
        }
        <!-- ENERGY TYPE -->
        @if (showEnergyInput('ENERGY_SELECT')) {
          <div class="form-field">
            <label for="energy_type_id">{{ 'Related energy' | translate }} ({{ 'core.utils.document_types.requirement_mandatory' | translate | lowercase }})</label>
            <nb-select
              id="energy_type_id"
              formControlName="energy_type_id"
              fullWidth
            >
              @for (energyType of visibleEnergyTypes(energyTypes$ | async, i); track energyType.id) {
                <nb-option
                  [value]="energyType.id"
                  [disabled]="isEnergyTypeDisabled(energyType.id, i)"
                >
                  {{ energyType.name }}
                </nb-option>
              }
            </nb-select>
          </div>
        }

        <!-- REFRIGERANT TYPE -->
        @if (showRefrigerantInput) {
          <div class="form-field">
            <label for="refrigerant_type_id">{{ 'Concerned refrigerant fluid' | translate }}</label>
            <nb-select
              id="refrigerant_type_id"
              formControlName="refrigerant_type_id"
              fullWidth
            >
              @for (rtype of refrigerantTypes$ | async; track rtype.id) {
                <nb-option [value]="rtype.id">
                  {{ rtype.name }}
                </nb-option>
              }
            </nb-select>
          </div>
        }

        <!-- ORIGIN -->
        <div class="form-field">
          <label for="gain_origin_id">{{ 'Source' | translate }} {{"(optional)" | translate}}</label>
          <nb-select
            id="gain_origin_id"
            formControlName="gain_origin_id"
            fullWidth
          >
            @for (go of (gainOrigins$ | async); track go.id) {
              <nb-option [value]="go.id">
                {{ go.name }}
              </nb-option>
            }
          </nb-select>
        </div>
      </div>
    </ng-template>
  `,
  styleUrls: [
    '../wizard-index.component.scss',
    '../../../side-forms/base-form/base-form.component.scss',
    './gain-energy-carbon.component.scss',
  ],
})
export class GainEnergyCarbonComponent implements OnInit, IInvestmentWizard {
  readonly stateKey = 'GAIN_ENERGY_CARBON';
  state = () => this.wizardService.getState(this.stateKey);

  @Output() formChanged = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  private rightPanelDialogService = inject(RightPanelDialogService);
  private irService = inject(InitiativeResponsiblesService);
  private wizardService = inject(InvestmentWizardService);
  private destroyRef = inject(DestroyRef);
  private initiativesService = inject(InitiativesService);
  private scopeService = inject(ScopeService);
  private fb = inject(FormBuilder);
  private perimeterEnergyTrajectoryService = inject(PerimeterEnergyTrajectoryService);

  private petrajLoaded = false;
  private petrajEnergyTypeIds: Set<number> = new Set();

  filteredResponsible$: Observable<string[]>;
  gainOrigins$: Observable<KPI.GainOrigin[]> = this.initiativesService.gainOrigins$;
  refrigerantTypes$ = this.scopeService.refrigerantTypes$.pipe(
    idMapToArray(),
  );
  energyTypes$ = this.initiativesService.initiativeEnergyTypes$;

  energyCarbonForm: FormGroupFromWithArray<InitiativeForm> = new FormGroup({
    enabled: new FormControl<boolean>(false),
    responsible: new FormControl(''),
    initially_proposed_by: new FormControl(''),
    description: new FormControl(''),
    initiative_type: new FormControl<KPI.InitiativeType>(null),
    gains: new FormArray([]),
  });

  // Getter (not a field) so the close cross appears even when investmentId is
  // set by the host wrapper just after this component is constructed.
  get existingInvestment(): boolean {
    return !!this.wizardService.investmentId;
  }

  private initialValues: Partial<InitiativeForm> = {};

  ngOnInit(): void {
    this.irService.loadResponsibles();
    this.setFilter('');

    const site = this.wizardService.getState('SITE_SELECTION');
    if (site?.id) {
      this.perimeterEnergyTrajectoryService.getPerimeterEnergyTrajectories(site.id).pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe((trajectories) => {
        this.petrajEnergyTypeIds = new Set(
          trajectories
            .filter((t) => t.trajectory_records?.some((r) => r.consumption != null))
            .map((t) => t.energy_type)
        );
        this.petrajLoaded = true;
      });
    }

    this.gains.setValidators([this.duplicateEnergyTypeValidator.bind(this)]);

    const state = this.state();
    if (state) {
      this.energyCarbonForm.patchValue(state);
      const gains = state.gains || [];
      gains.forEach(gain => this.addGain(gain));
    }
    this.gains.updateValueAndValidity();

    this.gains.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.gains.updateValueAndValidity({ emitEvent: false });
      this.checkFormValidity();
    });

    this.subscribeToEnergyTypeChanges();

    this.energyCarbonForm.valueChanges.subscribe(value => {
      this.wizardService.setState(this.stateKey, <InitiativeForm>value);
      if (Object.keys(this.initialValues).length > 0) {
        this.formChanged.emit();
      }
      this.checkFormValidity();
    });

    setTimeout(() => {
      this.initialValues = R.clone(this.energyCarbonForm.getRawValue());
      this.checkFormValidity();
    }, 0);
  }

  private checkFormValidity(): void {
    const value = this.energyCarbonForm.getRawValue();
    if (!value.enabled) {
      this.wizardService.unblockCurrentStep();
      this.formChanged.emit();
      return;
    }
    const selectedType = this.energyCarbonForm.get('initiative_type').value;
    if (!selectedType) {
      this.wizardService.blockCurrentStep('Please select an initiative type');
      this.formChanged.emit();
      return;
    }
    if (selectedType.gain_type !== 'None') {
      if (this.isFormValid()) {
        this.wizardService.unblockCurrentStep();
      } else {
        this.wizardService.blockCurrentStep('Please fill in all required gain fields');
      }
    } else {
      this.wizardService.unblockCurrentStep();
    }
    this.formChanged.emit();
  }

  onChange(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    this.energyCarbonForm.controls['responsible'].setValue(inputElement.value);
    this.setFilter(inputElement.value);
  }

  setFilter(value: string) {
    this.filteredResponsible$ = this.irService.responsibles$.pipe(
      filter((state: any) => !state.loading),
      map((state: any) => {
        const responsiblesArray: string[] | undefined = state.data;
        if (!responsiblesArray || !Array.isArray(responsiblesArray)) {
          return [];
        }
        return responsiblesArray
          .filter(user => user.toLowerCase().includes(value.toLowerCase()))
          .sort();
      }),
    );
  }

  formToggle(enabled: boolean) {
    this.energyCarbonForm.get('enabled').setValue(enabled);
    if (enabled) {
      const ref = this.rightPanelDialogService.open(
        InitiativeTypeWrapperComponent,
        { closeOnBackdropClick: true },
      );
      (ref.componentRef.instance as InitiativeTypeWrapperComponent).typeSelected.pipe(
        takeUntilDestroyed(this.destroyRef),
      ).subscribe((type: KPI.InitiativeType) => {
        this.energyCarbonForm.get('initiative_type').setValue(type);
        ref.close();
      });
    } else {
      this.energyCarbonForm.patchValue({
        enabled: false,
        responsible: '',
        initially_proposed_by: '',
        description: '',
        initiative_type: null,
      });
      while (this.gains.length > 0) {
        this.gains.removeAt(0);
      }
    }
  }

  onResponsibleSelected($event: string) {
    this.energyCarbonForm.get('responsible').setValue($event);
  }

  get isAbandonType() {
    const fc = this.energyCarbonForm.get('initiative_type');
    if (!fc.value) return false;
    return fc.value?.gain_type === 'QUIT_FOSSIL';
  }

  get isGainTypeNone() {
    const fc = this.energyCarbonForm.get('initiative_type');
    if (!fc.value) return false;
    return fc.value?.gain_type === 'None';
  }

  get showRefrigerantInput() {
    const fc = this.energyCarbonForm.get('initiative_type');
    if (!fc.value) return false;
    return fc.value?.gain_type === 'CARBON';
  }

  private gainFieldsVisibility = (): GainFieldsVisibility => ({
    energyType: this.showEnergyInput('ENERGY_SELECT'),
    energyAmount: this.showEnergyInput('ENERGY_INPUT'),
    refrigerantType: this.showRefrigerantInput,
    co2Amount: this.showRefrigerantInput,
  });

  get gains() {
    return this.energyCarbonForm.get('gains') as FormArray & {
      controls: FormGroup[];
    };
  }

  // Only list energy types that actually have a PETraj (consumption trajectory) for the site.
  // Filtering the source array (rather than wrapping each <nb-option> in an @if) avoids
  // interfering with how nb-select collects its options via ContentChildren.
  visibleEnergyTypes(energyTypes: KPI.InitiativeEnergyType[], currentGainIndex: number): KPI.InitiativeEnergyType[] {
    return (energyTypes || []).filter((energyType) => this.isEnergyTypeVisible(energyType.id, currentGainIndex));
  }

  private isEnergyTypeVisible(energyTypeId: number, currentGainIndex: number): boolean {
    if (!energyTypeId) {
      return true;
    }

    // Never hide the value already selected for this gain, even if its trajectory
    // later disappeared, otherwise the select would show an empty option.
    const currentGain = this.gains.at(currentGainIndex) as FormGroup;
    if (currentGain?.get('energy_type_id')?.value === energyTypeId) {
      return true;
    }

    // Only filter once PETraj has actually loaded some data for the site — otherwise
    // (site not yet known, or the site genuinely has no declared consumption) every
    // type would look "without trajectory" and the whole list would wrongly disappear.
    if (!this.petrajLoaded || this.petrajEnergyTypeIds.size === 0) {
      return true;
    }

    // PETraj restriction:
    // - QUIT_FOSSIL 2nd gain (index 1): no restriction — any energy type may be used
    //   (the new alternative energy might not have a trajectory yet)
    // - All other cases: restrict to energy types that already have a PETraj
    const shouldCheckPetraj = !(this.isAbandonType && currentGainIndex === 1);
    if (shouldCheckPetraj && !this.petrajEnergyTypeIds.has(energyTypeId)) {
      return false;
    }

    return true;
  }

  isEnergyTypeDisabled(energyTypeId: number, currentGainIndex: number): boolean {
    if (!energyTypeId) {
      return false;
    }

    for (let i = 0; i < this.gains.length; i++) {
      if (i === currentGainIndex) {
        continue;
      }
      const gain = this.gains.at(i) as FormGroup;
      if (gain) {
        const selectedEnergyTypeId = gain.get('energy_type_id')?.value;
        if (selectedEnergyTypeId === energyTypeId) {
          return true;
        }
      }
    }

    return false;
  }

  removeGain(index: number) {
    if (index === 0 && this.gains.length === 1) {
      this.gains.controls[0].reset();
    } else {
      this.gains.removeAt(index);
    }
    this.gains.updateValueAndValidity({ emitEvent: false });
    this.checkFormValidity();
    this.formChanged.emit();
  }

  addGain(gainValue?: any): void {
    if (!gainValue) {
      gainValue = {
        id: null,
        initiative_id: null,
        energy_type_id: null,
        refrigerant_type_id: null,
        gain_origin_id: null,
        gain_precision_id: null,
        theoretical_savings_full_year: null,
        theoretical_savings_first_year: null,
        theoretical_greenhouse_gas_savings_full_year: null,
        theoretical_greenhouse_gas_savings_first_year: null,
        real_savings: null,
        real_greenhouse_gas_savings: null,
        full_stop: false,
      };
    }
    const newGainGroup = this.fb.group(
      gainValue,
      { validators: [gainValidator(this.gainFieldsVisibility), Validators.required] },
    );

    this.gains.push(newGainGroup);

    this.subscribeToEnergyTypeControl(newGainGroup);
  }

  public showEnergyInput(type: 'ENERGY_SELECT' | 'ENERGY_INPUT') {
    const fc = this.energyCarbonForm.get('initiative_type');
    if (!fc.value) return false;
    const iniType = fc.value;
    return type === 'ENERGY_SELECT'
      ? iniType?.gain_type === 'ENERGY' || iniType?.gain_type === 'QUIT_FOSSIL'
      : iniType?.gain_type === 'ENERGY';
  }

  private filterEmptyGains(gains: any[]): any[] {
    if (!gains || !Array.isArray(gains)) {
      return [];
    }

    return gains.filter(gain => {
      if (!gain || typeof gain !== 'object') {
        return false;
      }

      const hasData = Object.keys(gain).some(key => {
        const value = gain[key];
        return value !== null && value !== undefined && value !== '' && value !== false;
      });

      return hasData;
    });
  }

  public getFilteredGains(): any[] {
    return this.filterEmptyGains(this.gains.value);
  }

  public isFormValid(): boolean {
    if (!this.energyCarbonForm) {
      return false;
    }

    if (!this.energyCarbonForm.get('enabled').value) {
      return true;
    }

    const selectedType = this.energyCarbonForm.get('initiative_type').value;
    if (!selectedType) {
      return false;
    }

    if (selectedType.gain_type === 'None') {
      return true;
    }

    const showsEnergySelect = this.showEnergyInput('ENERGY_SELECT');

    if (!showsEnergySelect) {
      return true;
    }

    const gainsArray = this.gains;
    if (!gainsArray || gainsArray.length === 0) {
      return true;
    }

    for (let i = 0; i < gainsArray.length; i++) {
      const gain = gainsArray.at(i) as FormGroup;
      if (!gain) continue;

      const energySavings = gain.get('theoretical_savings_full_year')?.value;
      const carbonSavings = gain.get('theoretical_greenhouse_gas_savings_full_year')?.value;
      const energyTypeId = gain.get('energy_type_id')?.value;
      const refrigerantTypeId = gain.get('refrigerant_type_id')?.value;

      const isEmptyGain = (!energySavings || energySavings === 0) &&
                          (!carbonSavings || carbonSavings === 0) &&
                          !energyTypeId &&
                          !refrigerantTypeId;

      if (isEmptyGain) {
        continue;
      }

      if (!energyTypeId || energyTypeId === null || energyTypeId === '') {
        return false;
      }
    }

    return true;
  }

  public anyFieldValueChanged(): boolean {
    if (!this.energyCarbonForm || Object.keys(this.initialValues).length === 0) {
      return false;
    }
    const currentValues = this.energyCarbonForm.getRawValue();
    return Object.keys(this.initialValues).some((key: string) => {
      const currentValue = currentValues[key];
      const initialValue = this.initialValues[key];

      if (key === 'gains') {
        return !R.equals(initialValue, currentValue);
      }

      return !R.equals(initialValue, currentValue);
    });
  }

  private duplicateEnergyTypeValidator(control: AbstractControl): ValidationErrors | null {
    const gainsArray = control as FormArray;
    if (!gainsArray || !gainsArray.controls) {
      return null;
    }

    if (!this.showEnergyInput('ENERGY_SELECT')) {
      return null;
    }

    const energyTypeIds: (number | null)[] = gainsArray.controls
      .map(gain => gain.get('energy_type_id')?.value)
      .filter(value => value != null && value !== '');

    const duplicates = energyTypeIds.filter((id, index) => energyTypeIds.indexOf(id) !== index);

    if (duplicates.length > 0) {
      return { duplicateEnergyType: true };
    }

    return null;
  }

  private subscribeToEnergyTypeChanges(): void {
    this.gains.controls.forEach((gain) => {
      this.subscribeToEnergyTypeControl(gain as FormGroup);
    });
  }

  private subscribeToEnergyTypeControl(gain: FormGroup): void {
    const energyTypeControl = gain.get('energy_type_id');
    if (energyTypeControl) {
      energyTypeControl.valueChanges.pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe(() => {
        this.gains.updateValueAndValidity({ emitEvent: false });
        this.checkFormValidity();
        this.formChanged.emit();
      });
    }
  }

  public refreshForm(): void {
    this.initialValues = { ...this.energyCarbonForm.getRawValue() };
  }

  public get initialGainsCount(): number {
    return (this.initialValues['gains'] as any[])?.length || 0;
  }
}
